import { render, staticRenderFns } from "./RecommendA.vue?vue&type=template&id=85748e5c&scoped=true&"
import script from "./RecommendA.vue?vue&type=script&lang=js&"
export * from "./RecommendA.vue?vue&type=script&lang=js&"
import style0 from "./RecommendA.vue?vue&type=style&index=0&id=85748e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85748e5c",
  null
  
)

export default component.exports